import Vue from 'vue';
import { ERRORS } from '@/assets/src/amplify/errors';

const amplifyMixin = Vue.extend({
  methods: {
    setError(error: any) {
      // TODO: Not a nice way to index into to object
      // @ts-ignore
      this.error = ERRORS[error.code] || error.message || error;
    },
  },

  data() {
    return {
      error: '' as string,
    };
  },
});

export default amplifyMixin;
